import { Box, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LocalePreferenceToggles from '../components/layout/LocalePreferenceToggles';
import DesignSystem from '../designSystem';
import { useThemeMode } from '../contexts/ThemeModeContext';
import { useT } from '../i18n/useT';

export default function MaintenancePage() {
  const { mode } = useThemeMode();
  const t = useT();
  const glow =
    mode === 'dark'
      ? 'radial-gradient(ellipse 80% 50% at 50% -20%, rgba(110,200,232,0.16), transparent)'
      : 'radial-gradient(ellipse 80% 50% at 50% -20%, rgba(31,122,155,0.16), transparent)';

  return (
    <Box
      className="landing-page"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        px: 3,
        bgcolor: DesignSystem.colors.canvas,
        backgroundImage: glow,
        color: DesignSystem.colors.textPrimary,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          pt: 2,
          pb: 1,
        }}
      >
        <Box sx={{ width: { xs: '100%', sm: 240 } }}>
          <LocalePreferenceToggles dense showLabels />
        </Box>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 700,
            fontSize: { xs: '1.5rem', sm: '1.75rem' },
            color: DesignSystem.colors.textPrimary,
            textAlign: 'center',
            mb: 1,
          }}
        >
          VisiMe
        </Typography>
        <Typography
          component="p"
          sx={{
            fontFamily: '"Roboto", sans-serif',
            fontSize: { xs: '1rem', sm: '1.1rem' },
            color: DesignSystem.colors.textSecondary,
            textAlign: 'center',
            maxWidth: 420,
          }}
        >
          {t('maintenanceTagline')}
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 2 }} alignItems="center">
          <Link
            component={RouterLink}
            to="/?login=1"
            underline="hover"
            sx={{
              fontWeight: 600,
              color: DesignSystem.colors.primary,
            }}
          >
            {t('maintenanceSignIn')}
          </Link>
          <Link
            component={RouterLink}
            to="/landing"
            underline="hover"
            sx={{
              fontWeight: 600,
              color: DesignSystem.colors.textSecondary,
            }}
          >
            {t('maintenanceLearnMore')}
          </Link>
        </Stack>
      </Box>
    </Box>
  );
}
